import React from 'react';
import { Loader2 } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { formatMsToReadable } from '../utils/formatMsToReadable';
import type { ReportViewItem } from '@/types/reports';

interface ViewsTableProps {
  data: ReportViewItem[];
  total: number;
  loading: boolean;
}

export const ViewsTable: React.FC<ViewsTableProps> = ({ data, total, loading }) => (
  <div className="rounded-lg overflow-hidden w-full mt-6 mb-6">
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>E-mail</TableHead>
          <TableHead className="text-center">Qtd. Visualizações</TableHead>
          <TableHead className="text-center">Última visualização</TableHead>
          <TableHead className="text-center">Tempo Médio</TableHead>
          <TableHead className="text-center">Permissão</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {loading ? (
          <TableRow>
            <TableCell colSpan={5} className="p-8 text-center">
              <div className="flex items-center justify-center gap-2 text-gray-500">
                <Loader2 className="w-5 h-5 animate-spin" />
                <span>Carregando acessos...</span>
              </div>
            </TableCell>
          </TableRow>
        ) : !data.length ? (
          <TableRow>
            <TableCell colSpan={5} className="p-8 text-center text-gray-500">
              Nenhum acesso encontrado
            </TableCell>
          </TableRow>
        ) : (
          data.map((row, index) => (
            <TableRow key={index}>
              <TableCell className="p-4 text-gray-600">{row.email}</TableCell>
              <TableCell className="p-4 text-center text-gray-600">{row.total_views}</TableCell>
              <TableCell className="p-4 text-center text-gray-600">
                {row.last_view_at ? format(new Date(row.last_view_at), 'dd/MM/yyyy HH:mm', { locale: ptBR }) : '—'}
              </TableCell>
              <TableCell className="p-4 text-center text-gray-600">{formatMsToReadable(row.average_view_time)}</TableCell>
              <TableCell className="p-4 text-center">
                <Badge
                  className={row.tag === 'GUEST' ? 'bg-blue-100 text-blue-800' : 'bg-gray-100 text-gray-800'}
                >
                  {row.tag === 'GUEST' ? 'Visitante' : row.tag}
                </Badge>
              </TableCell>
            </TableRow>
          ))
        )}
      </TableBody>
    </Table>
  </div>
);
